import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild,} from "@angular/core";
import {Subject, Subscription} from "rxjs";

import {Carteira} from "../../carteira/carteira.model";
import {MatStepper} from "@angular/material/stepper";
import {STEP_STATE} from "@angular/cdk/stepper";
import {ToastService} from "maps-angular-components";
import {AssociacaoGrupoCarteiraService} from "../associacao-grupo-carteira.service";
import {SelecaoGrupoCarteiraComponent} from "./selecao-grupo-carteira/selecao-grupo-carteira.component";
import {SelecaoCarteiraComponent} from "./selecao-carteira/selecao-carteira.component";
import {DadosCarteiraGrupoCarteiraModel} from "./dados-carteira-grupo-carteira.model";
import {GrupoCarteira} from "../../grupo-carteira/grupo-carteira";
import {indicate} from "../../shared/util/loading-indicate";

@Component({
  selector: "app-associacao-stepper",
  templateUrl: "./associacao-grupo-carteira-stepper.component.html",
  styleUrls: ["./associacao-grupo-carteira-stepper.component.scss"],
})
export class AssociacaoGrupoCarteiraStepper implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("stepper", {static: true}) public stepper: MatStepper;
  @ViewChild("selecaoGrupoCarteiraComponent", {static: false}) private readonly selecaoGrupoCarteiraComponent: SelecaoGrupoCarteiraComponent;
  @ViewChild("selecaoCarteiraComponent", {static: false}) private readonly selecaoCarteiraComponent: SelecaoCarteiraComponent;

  private readonly subscriptions = new Subscription();
  loading$ = new Subject<boolean>();
  isDisabled: boolean;

  carteiraGrupoCarteira$: Subject<DadosCarteiraGrupoCarteiraModel> = new Subject<DadosCarteiraGrupoCarteiraModel>();
  dadosCarteiraGrupoCarteira = new DadosCarteiraGrupoCarteiraModel();

  constructor(
    private readonly messageService: ToastService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    public associacaoGrupoCarteiraService: AssociacaoGrupoCarteiraService,
  ) {
  }

  ngOnInit() {
    this.isDisabled = true;
  }

  ngAfterViewInit(): void {
    this.stepper._getIndicatorType = () => STEP_STATE.NUMBER;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  doneStepper() {
    this.criar();
    this.changeDetectorRef.detectChanges();
  }

  criar() {
    this.associacaoGrupoCarteiraService
      .associar(this.dadosCarteiraGrupoCarteira.grupo, this.dadosCarteiraGrupoCarteira.carteiras)
      .pipe(indicate(this.loading$))
      .subscribe(
        () => {
          this.limpar();
          this.messageService.textoLight(
            "Associação da(s) carteira(s) e grupos(s) realizada com sucesso."
          );
        },
        err => {
          this.messageService.erro("Erro ao executar associação: " + err.error.message);
        }
      );
  }

  limpar() {
    this.selecaoGrupoCarteiraComponent.clear();
    this.selecaoCarteiraComponent.clear();
    this.stepper.reset();
    this.dadosCarteiraGrupoCarteira.grupo = null;
    this.dadosCarteiraGrupoCarteira.carteiras = []
    this.checkButtonDisabled()
  }

  updateGrupoCarteria($event: GrupoCarteira) {
    this.dadosCarteiraGrupoCarteira.grupo = $event;
    this.carteiraGrupoCarteira$.next(this.dadosCarteiraGrupoCarteira);
    this.checkButtonDisabled();
  }

  updateCarteira($event: Carteira[]) {
    this.dadosCarteiraGrupoCarteira.carteiras = $event;
    this.carteiraGrupoCarteira$.next(this.dadosCarteiraGrupoCarteira);
    this.checkButtonDisabled();
  }

  private checkButtonDisabled() {
    this.isDisabled = !this.validateAllFieldsFilled();
  }

  private validateAllFieldsFilled() {
    return this.dadosCarteiraGrupoCarteira.grupo != null &&
      this.dadosCarteiraGrupoCarteira.carteiras.length > 0;
  }
}
